import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import Button, { TYPES } from 'components/Button';
import { Container, Grid, Cell } from 'components/Grid';
import { SecondaryHeading } from 'components/Headings';
import Input from 'components/Input';
import Modal from 'components/Modal';
import Paragraph from 'components/Paragraph';
import { SubBold } from 'components/Sub';
import { mediumUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';
import Validator from 'utils/Validator';

const MIN_DESKTOP_HEIGHT = 475;
const MIN_DESKTOP_MOBILE = 455;

class PdpColorwayUpdatesFormModal extends PureComponent {
  static propTypes = {
    currentProduct: PropTypes.shape({}).isRequired,
    isOpen: PropTypes.bool,
    closeModal: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isOpen: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      email: '',
      isValid: null,
      hasSubmitted: false,
    };
  }

  handleSubmit = event => {
    event.preventDefault();

    const { email } = this.state;
    const { onSubmit } = this.props;

    const isValid = Validator.isEmail(email);

    this.setState(() => ({ isValid }));

    if (isValid) {
      this.setState(() => ({ hasSubmitted: true }));
      onSubmit({
        emailAddress: email,
        origination: 'productUpdatesForm',
        pdpSignupFlow: 'soldOut',
      });
    }
  };

  handleBlur = () => {
    this.setState({ isValid: null });
  };

  handleTextChange = event => {
    const email = event.target.value;

    this.setState(() => ({ email }));
  };

  render() {
    const { isOpen, closeModal } = this.props;

    return (
      <Modal
        className="PdpColorwayUpdatesFormModal"
        isOpen={isOpen}
        portalClassName="PdpColorwayUpdatesFormModal"
        onRequestClose={closeModal}
      >
        {this.state.hasSubmitted ? (
          <Container className="PdpColorwayUpdatesFormModal__text-wrapper PdpColorwayUpdatesFormModal__success-wrapper">
            <Grid isCentered>
              <Cell small={{ columns: 12 }} medium={{ columns: 11 }} largeUp={{ columns: 8 }}>
                <div className="PdpColorwayUpdatesFormModal__row">
                  <SecondaryHeading className="PdpColorwayUpdatesFormModal__success-header">
                    {I18n.localize(`emailCapture.successHeader`)}
                  </SecondaryHeading>
                </div>
                <Paragraph>{I18n.localize(`emailCapture.successDescription`)}</Paragraph>
              </Cell>
            </Grid>
          </Container>
        ) : (
          <Container className="PdpColorwayUpdatesFormModal__text-wrapper">
            <Grid isCentered>
              <Cell small={{ columns: 12 }} medium={{ columns: 11 }} largeUp={{ columns: 11 }}>
                <SecondaryHeading className="PdpColorwayUpdatesFormModal__header">
                  {I18n.localize('pdp.colorwayUpdateForm.heading')}
                </SecondaryHeading>
              </Cell>
              <Cell small={{ columns: 12 }} medium={{ columns: 11 }} largeUp={{ columns: 8 }}>
                <Paragraph className="PdpColorwayUpdatesFormModal__description">
                  {I18n.localize('pdp.colorwayUpdateForm.description')}
                </Paragraph>
              </Cell>
              <Cell small={{ columns: 12 }} medium={{ columns: 11 }} largeUp={{ columns: 7 }}>
                <SubBold className="PdpColorwayUpdatesFormModal__form-title">
                  {I18n.localize('pdp.colorwayUpdateForm.emailAddress')}
                </SubBold>
                <form className="PdpColorwayUpdatesFormModal__form" onSubmit={this.handleSubmit}>
                  <div className="PdpColorwayUpdatesFormModal__input-container">
                    <div className="PdpColorwayUpdatesFormModal__input-cell">
                      <Input
                        inputType="text"
                        id="PdpColorwayUpdatesFormModal__input"
                        className="PdpColorwayUpdatesFormModal__input"
                        isValid={this.state.isValid}
                        onChange={this.handleTextChange}
                        onBlur={this.handleBlur}
                        ariaLabel={I18n.localize('emailCapture.enterYourEmail')}
                        placeholder={I18n.localize('emailCapture.enterYourEmail')}
                      />

                      {this.state.isValid === false && (
                        <div className="PdpColorwayUpdatesFormModal__error">
                          <SubBold className="PdpColorwayUpdatesFormModal__error-text">
                            {I18n.localize('footer.emailSignUpErrorText')}
                          </SubBold>
                        </div>
                      )}
                    </div>

                    <div className="PdpColorwayUpdatesFormModal__button-cell">
                      <Button
                        isSubmit
                        type={TYPES.DEFAULT}
                        isFullWidth
                        id="PdpColorwayUpdatesFormModal__submit-button"
                        className="PdpColorwayUpdatesFormModal__submit-button"
                      >
                        {I18n.localize('pdp.addToCart.getNotified')}
                      </Button>
                    </div>
                    <Paragraph className="PdpColorwayUpdatesFormModal__disclaimer">
                      {I18n.localize('pdp.colorwayUpdateForm.disclaimer')}
                    </Paragraph>
                  </div>
                </form>
              </Cell>
            </Grid>
          </Container>
        )}
        <style jsx>
          {`
            .PdpColorwayUpdatesFormModal__button-cell {
              margin-top: ${Theme.get('spacing') * 4}px;
              margin-bottom: ${Theme.get('spacing') * 2}px;
            }

            @media ${mediumUp} {
              .PdpColorwayUpdatesFormModal__button-cell {
                margin-bottom: ${Theme.get('spacing') * 3}px;
              }
            }
          `}
        </style>
        <style jsx global>
          {`
            .PdpColorwayUpdatesFormModal__text-wrapper.Container {
              display: flex;
              flex-direction: column;
              text-align: center;
              justify-content: center;
              padding-top: ${Theme.get('spacing') * 3}px;
              padding-bottom: ${Theme.get('spacing') * 3}px;
              min-height: ${MIN_DESKTOP_MOBILE}px;
            }

            .PdpColorwayUpdatesFormModal__header.typography--secondary-heading,
            .PdpColorwayUpdatesFormModal__success-header.typography--secondary-heading {
              margin-bottom: ${Theme.get('spacing') * 3}px;
            }

            .PdpColorwayUpdatesFormModal__description.Paragraph {
              margin-bottom: ${Theme.get('spacing') * 5}px;
            }

            .PdpColorwayUpdatesFormModal__form-title.Sub--bold {
              text-align: left;
            }

            .PdpColorwayUpdatesFormModal__error-text.Sub--bold {
              text-align: left;
              color: ${Theme.get('colors-error')};
            }

            .PdpColorwayUpdatesFormModal__disclaimer.Paragraph {
              font-size: 14px;
              color: ${Theme.get('colors-black-60')};
              text-align: left;
            }

            @media ${mediumUp} {
              .PdpColorwayUpdatesFormModal.ReactModal__Content {
                padding: 0;
                width: 75vw;
              }

              .PdpColorwayUpdatesFormModal__description.Paragraph {
                margin-bottom: ${Theme.get('spacing') * 7}px;
              }

              .PdpColorwayUpdatesFormModal__text-wrapper.Container {
                min-height: ${MIN_DESKTOP_HEIGHT}px;
                padding-top: ${Theme.get('spacing') * 9}px;
                padding-bottom: ${Theme.get('spacing') * 9}px;
              }
            }
          `}
        </style>
      </Modal>
    );
  }
}
export default PdpColorwayUpdatesFormModal;
